const DEVICE_ID_STORAGE_KEY = 'trustedDeviceId';

function newDeviceId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        const bytes = crypto.getRandomValues(new Uint8Array(16));
        return `dev-${Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')}`;
    }
    // Only reached without any Web Crypto API at all (very old/non-browser environments) —
    // Math.random is not cryptographically secure, but this is a last-resort fallback.
    return `dev-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/** Stable per-browser id used to let the backend recognize a previously 2FA-trusted device. */
export function getOrCreateDeviceId(): string {
    const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existing) return existing;
    const id = newDeviceId();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, id);
    return id;
}
